import { useForm } from 'react-hook-form';
import { useId } from 'react';
import { User } from '../../../user';
import { AccountSettingsPanel } from '../account-settings-panel';
import { Button } from '@common/ui/buttons/button';
import { Form } from '@common/ui/forms/form';
import { FormTextField } from '@common/ui/forms/input-field/text-field/text-field';
import { useUpdateAccountDetails } from './update-account-details';
import { Trans } from '@common/i18n/trans';
import { useUploadAvatar } from '../avatar/upload-avatar';
import { useRemoveAvatar } from '../avatar/remove-avatar';
import { FormImageSelector } from '@common/ui/images/image-selector';
import { FileUploadProvider } from '@common/uploads/uploader/file-upload-provider';

interface Props {
  user: User;
}
export function BasicInfoPanel({ user }: Props) {
  const uploadAvatar = useUploadAvatar({ user });
  const removeAvatar = useRemoveAvatar({ user });
  const formId = useId();
  const form = useForm<Partial<Omit<User, 'subscriptions'>>>({
    defaultValues: {
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      avatar: user.avatar,
      email: user.email,
      email2: user.email2,
      company: user.company,
      designation: user.designation,
      mobile:user.mobile,
      address: user.address || '', 
      city: user.city || '', 
      country: user.country || '', 
      zipcode: user.zipcode || '', 
    },
  });
  const updateDetails = useUpdateAccountDetails(form);
  
  console.log({
    first_name: user.first_name || '',
    last_name: user.last_name || '',
    avatar: user.avatar,
    email: user.email,
    email2: user.email2,
    company: user.company,
    designation: user.designation,
    mobile:user.mobile
  })

  return (
    <AccountSettingsPanel
      title={<Trans message="Update name and profile image"/>}
      actions={
        <Button
          type="submit"
          variant="flat"
          color="primary"
          form={formId}
          disabled={updateDetails.isLoading || !form.formState.isValid}
        >
          <Trans message="Save" />
        </Button>
      }
    >
      <Form
        form={form}
        className="flex flex-col flex-col-reverse md:flex-row  gap-40 md:gap-80  "
        onSubmit={newDetails => {
          updateDetails.mutate(newDetails);
        }}
        id={formId}
      >
        <div className="flex-auto w-full">
          <FormTextField
            className="mb-24 "
            id='cus_mail'
            name="first_name"
            label={<Trans message="First Name" />}
          />
          <FormTextField
            className="mb-24 "
            id='cus_mail'
            name="last_name"
            label={<Trans message="Last Name" />}
          />
          <FormTextField
            className="mb-24 "
            name="email"
            id='email'
            label={<Trans message="Email Address (Office)" />}
            type='Email'
          />
          <FormTextField
            className="mb-24 "
            id='email2'
            name="email2"
            label={<Trans message="Email Address (Personal)" />}
            type='Email'
          />
          <FormTextField
            className="mb-24"
            id='company'
            name="company"
            label={<Trans message="Company" />}
          />
          <FormTextField
            className="mb-24"
            id='designation'
            name="designation"
            label={<Trans message="Designation" />}
          />
          <FormTextField
            className="mb-24"
            name="mobile"
            label={<Trans message="Mobile Number" />}
            type="text"
            placeholder='eg. +8801XXXXXXXXX'
          />
          <FormTextField
          className="mb-24"
          name="city"
          label={<Trans message="City" />}
          type="text"
          placeholder='eg. Istanbul'
          />
          <FormTextField
          className="mb-24"
          name="country"
          label={<Trans message="Country" />}
          type="text"
          placeholder='eg. Turkey'
          />
          <FormTextField
          className="mb-24"
          name="zipcode"
          label={<Trans message="Zip Code" />}
          type="text"
            placeholder='eg. 34000'
          />
          <FormTextField
          className="mb-24"
          name="address"
          label={<Trans message="Address" />}
          type="text"
          placeholder='eg. 123/2, Example Street, Example Area'
          />
        </div>
        <FileUploadProvider>
          <FormImageSelector
            className="md:mr-80 imgProfle text-center"
            variant="avatar"
            previewSize="w-110 h-110"
            showRemoveButton
            name="avatar"
            diskPrefix="avatars"
            label={<Trans message="Profile image" />}
            onChange={url => {
              if (url) {
                uploadAvatar.mutate({ url });
              } else {
                removeAvatar.mutate();
              }
            }}
          />
        </FileUploadProvider>
      </Form>
    </AccountSettingsPanel>
  );
}
